import type { Meta, StoryObj } from '@storybook/react';

import { ChallengeSettingsSheet } from './ChallengeSettingsSheet';

const meta = {
  title: 'Challenges/ChallengeSettingsSheet',
  component: ChallengeSettingsSheet,
  args: {
    visible: true,
    onClose: () => undefined,
    reminderEnabled: true,
    reminderTime: '18:00',
    onSaveReminder: () => undefined,
    onStopChallenge: () => undefined,
  },
} satisfies Meta<typeof ChallengeSettingsSheet>;

export default meta;

type Story = StoryObj<typeof meta>;

export const ReminderOn: Story = {};

export const ReminderOff: Story = {
  args: {
    reminderEnabled: false,
    reminderTime: '',
  },
};
